export default __webpack_public_path__ + "static/media/pic69.6624c383.jpg";